const p = new URLSearchParams(location.search);

// Extract city from path like /chicago or /nyc
function getCityFromPath(): string | null {
  const path = location.pathname.slice(1); // remove leading /
  if (path && !path.includes('/') && !path.includes('.')) {
    return path.toLowerCase();
  }
  return null;
}

export function hydrate() {
  p.forEach((v, k) => {
    const field = document.getElementById(k);
    if (field) {
      field.value = v;
    }
  });
}

export function params() {
  const cityFromPath = getCityFromPath();
  return {
    zip: p.get('zip') || cityFromPath,
    search: p.get('search'),
    lat: p.get('lat'),
    lon: p.get('lon'),
    dismissed: p.get('dismissed')
  }
}
